import React, { Component } from 'react';
import Modal from './_Modal';
import styled from 'styled-components';

const Buttons = styled.div`
  text-align: center;
  margin-top: 15px;
  button {
    background-color: #69f;
    border: none;
    border-radius: 5px;
    margin: 20px;
    color: white;
    &:hover {
      background-color: #36e;
    }
  }
`

class SaveForkModal extends Component {
  render() {
    return (
      <Modal
        open={this.props.open}
        close={() => this.props.closeModal(this.props.method)}
      >
        <h4>Something went wrong with loading your envelope.</h4>
        <h4>Please try to reload your browser</h4>
        <Buttons>
          <button onClick={() => window.location.reload()}>
            Reload
          </button>
        </Buttons>
      </Modal>
    )
  }
}

export default SaveForkModal;



// WEBPACK FOOTER //
// ./src/_FailedLoadModal.js